<template>
    <div id="app" class="app" :class="{
        'logged-in': !isEmpty('user'),
        unauth: isEmpty('user'),
        'messages-page': $route.name == 'threads',
        'app-overlay': isScrolled,
    }">
        <div class="images-preload"></div>
        <Header v-if="$route.name != 'quick-registration'"></Header>
        <MordaLenta v-if="$route.name != 'quick-registration'"></MordaLenta>
        <div class="wrapper container">
            <SideMenu v-if="$route.name != 'quick-registration'"></SideMenu>
            <Loader v-if="loading"></Loader>
            <div v-else class="content">
                <Games v-if="$route.name != 'quick-registration' &&
                    $route.name != 'threads' &&
                    $route.name != 'search' &&
                    $route.name != 'profile' &&
                    $route.name != 'albums' &&
                    $route.name != 'video-albums' &&
                    $route.name != 'videos' &&
                    $route.name != 'photos' &&
                    $route.name != 'my-puzzles' &&
                    $route.name != 'puzzles' &&
                    $route.name != 'events' &&
                    $route.name != 'balance' &&
                    $route.name != 'stories' &&
                    $route.name != 'horoscope' &&
                    $route.name != 'games' &&
                    $route.name != 'game'
                    "></Games>
                <div class="content-inner">
                    <router-view></router-view>
                </div>
            </div>
        </div>
        <Footer v-if="$route.name != 'quick-registration'"></Footer>
        <!-- <ThemePicker v-if="!isEmpty('user')"></ThemePicker> -->
        <MordaLentaBuy v-if="init && init.costs" />
        <MordaLentaWin />
        <MordaLentaGifts />
        <VipBuy />
        <PhotoDetails />
        <PuzzleDetails :myPuzzle="currentPuzzleItem" />
        <ImageDetails />
        <UploadPhotos />
        <MovePhotos />
        <CreateAlbum />
        <Roulette />
        <RouletteResult />
        <UploadAvatar />
        <Puzzle />
        <MyGifts />
        <GiftsList />
        <SendGift />
        <BalanceIn />
        <BalanceOut />
        <WelcomeModal />
        <Login />
        <Register />
        <FirstLogin />
        <FirstLogin2 />
        <FirstLogin3 />
        <FirstLogin4 />
        <ResetPassword />
        <ResetPasswordPhone />
        <ConfirmPhone />
        <NewPassword />
        <CropPuzzle />
        <v-dialog />
        <audio id="invite-sound" class="hidden-audio" preload="auto">
            <source src="@/assets/sounds/invite.m4a" type="audio/mp4" />
        </audio>
        <audio id="win-sound" class="hidden-audio" preload="auto">
            <source src="@/assets/sounds/win.m4a" type="audio/mp4" />
        </audio>
        <audio id="lose-sound" class="hidden-audio" preload="auto">
            <source src="@/assets/sounds/lose.m4a" type="audio/mp4" />
        </audio>
        <audio id="win-roulette-sound" class="hidden-audio" preload="auto">
            <source src="@/assets/sounds/win.m4a" type="audio/mp4" />
        </audio>
        <audio id="lose-roulette-sound" class="hidden-audio" preload="auto">
            <source src="@/assets/sounds/lose.m4a" type="audio/mp4" />
        </audio>
        <audio id="spin-sound" class="hidden-audio" preload="auto">
            <source src="@/assets/sounds/spin.m4a" type="audio/mp4" />
        </audio>
        <audio id="timing-sound" class="hidden-audio" preload="auto">
            <source src="@/assets/sounds/timing.m4a" type="audio/mp4" />
        </audio>
        <notifications group="invite" position="bottom right" :closeOnClick="false" :max="1">
            <template slot="body" slot-scope="props">
                <InviteNotification :props="props"></InviteNotification>
            </template>
        </notifications>
        <notifications position="bottom right" :duration="4000" />
    </div>
</template>

<script>
import Vue from "vue";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
// import ThemePicker from '@/components/ThemePicker';
import SideMenu from "@/components/SideMenu";
import { mapGetters, mapActions } from "vuex";
import Login from "@/components/Modals/Login";
import Register from "@/components/Modals/Register";
import WelcomeModal from "@/components/Modals/WelcomeModal";
import FirstLogin from "@/components/Modals/FirstLogin";
import FirstLogin2 from "@/components/Modals/FirstLogin2";
import FirstLogin3 from "@/components/Modals/FirstLogin3";
import FirstLogin4 from "@/components/Modals/FirstLogin4";
import MordaLenta from "@/components/Blocks/MordaLenta";
import MordaLentaBuy from "@/components/Modals/MordaLentaBuy";
import MordaLentaWin from "@/components/Modals/MordaLentaWin";
import MordaLentaGifts from "@/components/Modals/MordaLentaGifts";
import Games from "@/components/Blocks/Games";
import ConfirmPhone from "@/components/Modals/ConfirmPhone";
import VipBuy from "@/components/Modals/VipBuy";
import PhotoDetails from "@/components/Modals/PhotoDetails";
import PuzzleDetails from "@/components/Modals/PuzzleDetails";
import ImageDetails from "@/components/Modals/ImageDetails";
import BalanceIn from "@/components/Modals/BalanceIn";
import BalanceOut from "@/components/Modals/BalanceOut";
import CreateAlbum from "@/components/Modals/CreateAlbum";
import UploadPhotos from "@/components/Modals/UploadPhotos";
import MovePhotos from "@/components/Modals/MovePhotos";
import Roulette from "@/components/Modals/Roulette";
import RouletteResult from "@/components/Modals/RouletteResult";
import UploadAvatar from "@/components/Modals/UploadAvatar";
import CropPuzzle from "@/components/Modals/CropPuzzle";
import Puzzle from "@/components/Modals/Puzzle";
import MyGifts from "@/components/Modals/MyGifts";
import GiftsList from "@/components/Modals/GiftsList";
import SendGift from "@/components/Modals/SendGift";
import ResetPassword from "@/components/Modals/ResetPassword";
import ResetPasswordPhone from "@/components/Modals/ResetPasswordPhone";
import NewPassword from "@/components/Modals/NewPassword";
import Loader from "@/components/Loader";
import InviteNotification from "@/components/Blocks/InviteNotification";
import { declineNouns } from "@/mixins/declineNouns";
import { handleSocket } from "@/mixins/handleSocket";
import { initAfterLogin } from "@/mixins/initAfterLogin";

export default {
    name: "app",
    components: {
        Header,
        Footer,
        // ThemePicker,
        SideMenu,
        Login,
        Register,
        WelcomeModal,
        FirstLogin,
        FirstLogin2,
        FirstLogin3,
        FirstLogin4,
        MordaLenta,
        MordaLentaBuy,
        MordaLentaWin,
        MordaLentaGifts,
        Games,
        ConfirmPhone,
        VipBuy,
        PhotoDetails,
        PuzzleDetails,
        ImageDetails,
        BalanceIn,
        BalanceOut,
        CreateAlbum,
        UploadPhotos,
        MovePhotos,
        Roulette,
        RouletteResult,
        UploadAvatar,
        CropPuzzle,
        Puzzle,
        MyGifts,
        GiftsList,
        SendGift,
        ResetPassword,
        ResetPasswordPhone,
        NewPassword,
        InviteNotification,
        Loader,
    },
    provide() {
        return {
            setCurrentPuzzleItem: this.setCurrentPuzzleItem,
        };
    },
    mixins: [declineNouns, handleSocket, initAfterLogin],
    data() {
        return {
            lastScrollPos: 0,
            ticking: false,
            isScrolled: true,
            modalVisible: false,
            currentPuzzleItem: null,
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            isEmpty: "user/isEmpty",
            threads: "threads/fetchThreads",
            loading: "loader/fetchLoading",
            themes: "themes/fetchThemes",
            currentTheme: "themes/fetchCurrentTheme",
            init: "init/fetchInit",
            initIsEmpty: "init/isEmpty",
            eventsBalance: "eventsBalance/eventsBalance",
        }),
    },
    mounted() {
        const vm = new Vue();

        this.$store
            .dispatch("user/get", true)
            .then(() => {
                this.$store.dispatch("loader/setLoading", false);
                this.initAfterLogin();
                if (this.isEmpty("user")) {
                    /*if (this.$route.name != 'quick-registration') {
                                  this.$router.push({name: 'home'});
                              }*/
                } else {
                    vm.$connect();
                    if (
                        !this.user.first_name ||
                        !this.user.last_name ||
                        (this.user.gender != 1 && this.user.gender != 2) ||
                        !this.user.birthday
                    ) {
                        this.$modal.show("first-login");
                    }
                }
            })
            .catch(() => {
                this.$store.dispatch("loader/setLoading", false);
            });

        let rouletteSound = Boolean(Number(this.getCookie("rouletteSound")));
        this.$store.dispatch("roulette/setSound", rouletteSound);

        let arr = [];
        arr.push(document.getElementById("timing-sound"));
        arr.push(document.getElementById("spin-sound"));
        arr.push(document.getElementById("win-roulette-sound"));
        arr.push(document.getElementById("lose-roulette-sound"));
        for (let i in arr) {
            if (rouletteSound) {
                arr[i].muted = false;
            } else {
                arr[i].muted = true;
            }
        }
        document.title = this.$t('app.title');
    },
    async created() {
        document.title = this.$t('app.title');
        const refCode = this.$route.query.ref_code; // Получаем реферальный код из URL
        if (refCode) {
            // Если реферальный код есть в URL, вызываем метод для отправки на сервер
            this.sendRefCodeRequest(refCode);
        }

        this.$store.watch(
            (state, getters) => getters["sockets/message"],
            (msg) => {
                if (msg.event) {
                    this.handleSocket(msg);
                }
            }
        );
        window.addEventListener("scroll", this.checkOverlay);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.checkOverlay);
    },
    methods: {
        ...mapActions("eventsBalance", ["getEventsBalance"]),
        async sendRefCodeRequest(refCode) {
            try {
                const url = '/send_ref_code/';

                const response = await Vue.axios.post(url, { ref_code: refCode });

                if (response.data.status === 'ok') {
                    this.statusMessage = 'Реферальный код успешно отправлен';
                } else {
                    this.statusMessage = 'Реферальный код отсутствует';
                }
            } catch (error) {
                console.error('Ошибка при отправке реферального кода:', error);
            }
        },

        setCurrentPuzzleItem(puzzleItem) {
            this.currentPuzzleItem = puzzleItem;
            this.$modal.show("PuzzleDetails", {
                id: puzzleItem.id,
                feed: false,
                isVideo: false,
            });
        },
        openModal() {
            this.modalVisible = true; // Откройте модальное окно
        },
        checkOverlay() {
            this.lastScrollPos = window.pageYOffset;
            if (!this.ticking) {
                window.requestAnimationFrame(() => {
                    if (this.lastScrollPos > 40 && !this.isScrolled) {
                        this.isScrolled = true;
                    } else if (this.lastScrollPos <= 40 && this.isScrolled) {
                        this.isScrolled = false;
                    }
                    this.ticking = false;
                });
                this.ticking = true;
            }
        },
        getCookie(cname) {
            let name = cname + "=";
            let ca = window.document.cookie.split(";");
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
    },
};
</script>

<style lang="scss">
@import "~@/assets/styles/base/_reset";
@import "~@/assets/styles/base/_base";
@import "~@/assets/styles/layout/_info-block";
@import "~@/assets/styles/layout/_dialog";
@import "~@/assets/styles/layout/_modal";
@import "~@/assets/styles/components/_button";
@import "~@/assets/styles/components/_loader";
@import "~@/assets/styles/components/_link";
@import "~@/assets/styles/components/_user-item";
@import "~@/assets/styles/components/_multiselect";
@import "~@/assets/styles/components/_form";
@import "~@/assets/styles/components/_heading";
@import "~@/assets/styles/components/_tags-input";
@import "~@/assets/styles/components/_upload-image";
@import "~@/assets/styles/components/_context-menu";
@import "~@/assets/styles/components/_scrollbar";
@import "~@/assets/styles/components/_no-avatar";
@import "~@/assets/styles/components/_block-header";
@import "~@/assets/styles/layout/_roulette";
@import "~@/assets/styles/layout/_morda-lenta";
@import "~@/assets/styles/layout/_photo-details";
@import "~@/assets/styles/layout/_notifications";
</style>
